import {
  Box,
  Card,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  TextField,
  Autocomplete,
  Button,
} from "@mui/material";

import { CardListStack, ContentBox, RightFabButton } from "app/Common/Elements";
import React, { useEffect, useRef, useState } from "react";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { CardTopSection, CardContentSection } from "app/Common/Elements";

import cloneDeep from "lodash.clonedeep";
import { isFormValid } from "app/utils/InputValidations";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import SweetAlert from "app/Common/SweetAlert";
import ProjectCounterCard from "./ProjectCounterCard/ProjectCounterCard";
import SalesStatistics from "./SalesStatistics";
import StraightAnglePieChart from "./StraightAnglePieChart";
import ProductSalesList from "./ProductSalesList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GetReportingTilesDataThunk } from "../../../app/store/slice/dashboard-slice";
import {
  GetDeliveryReportingTabDataThunk,
  updateTabLoaders,
} from "../../../app/store/slice/report-slice";
import { dispatch } from "app/store/store";
import {
  getMinutesDifference,
  downloadJSONAsXLSX,
  getDaysDifference,
  multipleSelectValues,
  canViewConversionCost,
  canViewRevenue,
  getReportConversionCostLabel,
  getReportConversionCostMetricConfigs,
  getReportConversionMetricConfigs,
  getReportRevenueMetricConfigs,
  getTotalReportConversionCost,
  getTotalReportRevenue,
  numberFormat,
  shouldHideCpm,
  shouldHideSpend,
  stripPermissionHiddenReportFields,
} from "../../utils/utils";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import {
  GetReportingOverviewSummaryDataThunk,
  GetReportingOverviewGraphDataThunk,
  GetReportingTabsDataThunk,
} from "app/store/slice/report-slice";
import moment from "moment";
import AdjustOutlinedIcon from "@mui/icons-material/AdjustOutlined";
import MouseOutlinedIcon from "@mui/icons-material/MouseOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { GroupByList } from "app/utils/constants/data";
import Datagrid from "app/Common/Datagrid";
import { searchObjFromArrayOfObjs } from "app/utils/Validations";
import { object } from "prop-types";


const columns = [
  { field: "advertiser_id", headerName: "Advertiser ID", flex: 1 },
  { field: "advertiser_name", headerName: "Advertiser", flex: 1 },
  { field: "account_name", headerName: "Account", flex: 1 },
  { field: "account_id", headerName: "Account ID", flex: 1 },
];

const AD_GROUP_LABEL = "Ad Group";
const AD_GROUP_LABEL_PLURAL = "Ad Groups";
const CAMPAIGN_LABEL = "Campaign";
const CAMPAIGN_LABEL_PLURAL = "Campaigns";
const INVENTORY_REPORT_PERMISSION_KEY = "show_inventory_report";
const VIDEO_COMPLETE_LABEL = "Video Complete";
const LOCATION_REPORT_PERMISSION_KEYS = [
  "show_dma_wrapup_report",
  "show_loc_postal_code_wrapup_report",
  "show_loc_state_wrapup_report",
];

const Reporting = ({
  reportCampaignId,
  customMidContentHeight,
  reportStartDate,
  reportEndDate,
}) => {
  const {
    reportingTiles,
    reportingOverviewGraphData,
    reportingFilters,
    reportingTabsData,
    tabLoaders,
    groupByReportTiles,
  } = useSelector((state) => state.ReportReducer);

  const {
    dashboardDateFilter,
    globalAccount,
    globalAccountsList,
    authUserData,
    dmaStateCityList,
    globalBannersList,
    globalCampaignsList,
    globalPackagesList,
    globalPublishersList,
  } = useSelector((state) => state.CommonReducer);

  //console.log("Global Publishers List:", globalPublishersList);
  let reportingLabelPostion = "center";
  const [Expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const ToastRef = useRef();
  const [groupBy, setGroupBy] = React.useState(["account"]);
  const [groupByColumns, setGroupByColumns] = React.useState([]);

  const [groupByData, setGroupByData] = React.useState({
    summary: {
      impressions: 0,
      viewables: 0,
      clicks: 0,
      conversions: 0,
      conversions_2: 0,
      conversions_3: 0,
      conversions_4: 0,
      datacost: 0,
      spend: 0,
      margin: 0,
      net: 0,
      profit: 0,
      roi: 0,
    },
    graph: [],
  });
  const hideSpendMetrics = shouldHideSpend(authUserData);
  const availableAccounts = React.useMemo(
    () => (Array.isArray(globalAccountsList) ? globalAccountsList : []),
    [globalAccountsList]
  );
  const selectedReportAccount = React.useMemo(() => {
    if (availableAccounts.length === 1) {
      return availableAccounts[0];
    }
    if (reportingFilters.accounts?.length === 1) {
      return availableAccounts.find(
        (accountInfo) =>
          `${accountInfo.value}` === `${reportingFilters.accounts[0]}`
      );
    }

    const reportCampaignIds = Array.isArray(reportCampaignId)
      ? reportCampaignId
      : reportCampaignId != null && reportCampaignId !== ""
      ? `${reportCampaignId}`
          .split(",")
          .map((value) => value.trim())
          .filter((value) => value !== "")
      : [];

    if (reportCampaignIds.length === 1) {
      const campaignInfo = globalCampaignsList.find(
        (campaign) => `${campaign.value}` === `${reportCampaignIds[0]}`
      );
      if (campaignInfo?.accountid != null) {
        return availableAccounts.find(
          (accountInfo) => `${accountInfo.value}` === `${campaignInfo.accountid}`
        );
      }
    }

    return null;
  }, [availableAccounts, globalCampaignsList, reportCampaignId, reportingFilters.accounts]);

  const conversionLabel = React.useMemo(
    () => ({
      conv_1_label:
        selectedReportAccount?.conv_1_label &&
        `${selectedReportAccount.conv_1_label}`.trim() !== ""
          ? selectedReportAccount.conv_1_label
          : "Conversion-1",
      conv_2_label:
        selectedReportAccount?.conv_2_label &&
        `${selectedReportAccount.conv_2_label}`.trim() !== ""
          ? selectedReportAccount.conv_2_label
          : "Conversion-2",
      conv_3_label:
        selectedReportAccount?.conv_3_label &&
        `${selectedReportAccount.conv_3_label}`.trim() !== ""
          ? selectedReportAccount.conv_3_label
          : "Conversion-3",
      conv_4_label:
        selectedReportAccount?.conv_4_label &&
        `${selectedReportAccount.conv_4_label}`.trim() !== ""
          ? selectedReportAccount.conv_4_label
          : "",
    }),
    [selectedReportAccount]
  );

  const activeConversionMetrics = React.useMemo(
    () =>
      getReportConversionMetricConfigs({
        conversionLabel,
        hideReportMetrics: [],
        authUserData,
      }),
    [authUserData, conversionLabel]
  );

  const activeRevenueMetrics = React.useMemo(
    () =>
      getReportRevenueMetricConfigs({
        conversionLabel,
        hideReportMetrics: [],
        authUserData,
      }),
    [authUserData, conversionLabel]
  );

  const activeConversionCostMetrics = React.useMemo(
    () =>
      getReportConversionCostMetricConfigs({
        conversionLabel,
        hideReportMetrics: [],
        authUserData,
      }),
    [authUserData, conversionLabel]
  );

  const canShowConversions = activeConversionMetrics.length > 0;
  const canShowRevenue =
    !hideSpendMetrics &&
    canViewRevenue(authUserData) &&
    activeRevenueMetrics.length > 0;
  const canShowConversionCost =
    !hideSpendMetrics &&
    canViewConversionCost(authUserData) &&
    activeConversionCostMetrics.length > 0;

  const getConversionCostValue = React.useCallback((row = {}, field = "conversions") => {
    const conversions = Number(row?.[field] || 0);
    const spend = Number(row?.spend || 0);
    if (conversions <= 0 || spend <= 0) {
      return 0;
    }
    return Number((spend / conversions).toFixed(2));
  }, []);

  const getConversionCostSeriesKey = React.useCallback(
    (field = "conversions") =>
      field === "conversions"
        ? "conversion_cost_1"
        : field.replace("conversions_", "conversion_cost_"),
    []
  );

  const overviewGraphData = React.useMemo(
    () =>
      Array.isArray(reportingOverviewGraphData)
        ? reportingOverviewGraphData.map((rowInfo) => {
            const nextRow = { ...rowInfo };
            activeConversionCostMetrics.forEach((metricInfo) => {
              nextRow[getConversionCostSeriesKey(metricInfo.field)] =
                getConversionCostValue(rowInfo, metricInfo.field);
            });
            return nextRow;
          })
        : [],
    [
      activeConversionCostMetrics,
      getConversionCostSeriesKey,
      getConversionCostValue,
      reportingOverviewGraphData,
    ]
  );

  const inputLabels = React.useMemo(() => {
    const conversionColors = ["#4B0082", "#6A5ACD", "#A020F0", "#C71585"];
    const labels = [
      { key: "impressions", color: "#8884d8", displayName: "Impressions" },
      { key: "clicks", color: "#82ca9d", displayName: "Clicks" },
      ...activeConversionMetrics.map((metricInfo, index) => ({
        key: metricInfo.field,
        color: conversionColors[index] || "#4B0082",
        displayName: metricInfo.label,
      })),
    ];

    if (!hideSpendMetrics) {
      labels.push({ key: "spend", color: "#e96d8d", displayName: "Spend" });
    }

    if (canShowConversionCost) {
      activeConversionCostMetrics.forEach((metricInfo, index) => {
        labels.push({
          key: getConversionCostSeriesKey(metricInfo.field),
          color: ["#5C4033", "#8B5CF6", "#B45309", "#DC2626"][index] || "#5C4033",
          displayName: getReportConversionCostLabel(metricInfo.label),
        });
      });
    }

    if (canShowRevenue) {
      activeRevenueMetrics.forEach((metricInfo, index) => {
        labels.push({
          key: metricInfo.revenueField,
          color: ["#0EA5E9", "#14B8A6", "#F59E0B", "#EF4444"][index] || "#33ACFF",
          displayName: `Revenue (${metricInfo.label})`,
        });
      });
      labels.push({
        key: "roi",
        color: "#33ACFF",
        displayName: "Total Revenue",
      });
    }

    if (reportCampaignId != "" && reportCampaignId != null) {
      labels.push({
        key: "available",
        color: "#FFBB28",
        displayName: "Available",
      });
      labels.push({
        key: "qualify",
        color: "#FF8042",
        displayName: "Qualify",
      });
      labels.push({ key: "ctr", color: "#0080F7", displayName: "CTR" });
    }

    return labels;
  }, [
    activeConversionMetrics,
    activeConversionCostMetrics,
    canShowConversionCost,
    activeRevenueMetrics,
    canShowRevenue,
    reportCampaignId,
  ]);

  if (reportCampaignId != "" && reportCampaignId != null) {
    if (getDaysDifference(reportEndDate, reportStartDate) == 0) {
      reportingLabelPostion = "end";
    }
  } else {
    if (
      getDaysDifference(
        reportingFilters?.end_date,
        reportingFilters?.start_date
      ) == 0
    ) {
      reportingLabelPostion = "end";
    }
  }

  let inputLabelsImpClicks = [
    { key: "impressions", color: "#8884d8" },
    { key: "clicks", color: "#82ca9d" },
  ];
  const canViewInventoryReport =
    authUserData?.is_sys_admin == 1 ||
    authUserData?.user_permissions?.includes(
      INVENTORY_REPORT_PERMISSION_KEY
    ) === true;
  const canViewLocationReport =
    authUserData?.is_sys_admin == 1 ||
    LOCATION_REPORT_PERMISSION_KEYS.some(
      (permissionKey) =>
        authUserData?.user_permissions?.includes(permissionKey) === true
    );

  const [steps, setSteps] = useState([
    {
      name: "Overview",
      id: 0,
      fields: {},
    },
    {
      name: "Device",
      id: 1,
      fields: {},
    },
    {
      name: "Location",
      id: 2,
      fields: {},
    },
    {
      name: "Inventory",
      id: 3,
      fields: {},
    },
    {
      name: CAMPAIGN_LABEL,
      id: 4,
      fields: {},
    },
    {
      name: AD_GROUP_LABEL,
      id: 5,
      fields: {},
    },
    {
      name: "Creative",
      id: 6,
      fields: {},
    },
    {
      name: "Delivery Report",
      id: 7,
      fields: {},
    },
  ]);
  const visibleSteps = React.useMemo(
    () =>
      steps.filter((step) => {
        if (step.id === 2) return canViewLocationReport;
        if (step.id === 3) return canViewInventoryReport;
        return true;
      }),
    [steps, canViewInventoryReport, canViewLocationReport]
  );

  // const [tableColumns, setTableColumns] = useState([
  //   "impressions",
  //   "clicks",
  //   "complete",
  //   "conversions",
  // ]);

  const [tableColumns, setTableColumns] = useState([]);

  useEffect(() => {
    const formatNumber = (value) =>
      parseFloat(value || 0).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });

    const nextColumns = [
      {
        field: "impressions",
        headerName: "Impressions",
        flex: 1,
        valueFormatter: (params) => formatNumber(params?.value),
      },
      {
        field: "clicks",
        headerName: "Clicks",
        flex: 1,
        valueFormatter: (params) => formatNumber(params?.value),
      },
      {
        field: "complete",
        headerName: VIDEO_COMPLETE_LABEL,
        flex: 1,
        valueFormatter: (params) => formatNumber(params?.value),
      },
      {
        field: "ctr",
        headerName: "CTR",
        flex: 1,
        valueGetter: (params) => {
          const impressions = Number(params?.row?.impressions || 0);
          const clicks = Number(params?.row?.clicks || 0);
          return impressions > 0
            ? Number(((clicks / impressions) * 100).toFixed(2))
            : 0;
        },
        valueFormatter: (params) => `${formatNumber(params?.value)}%`,
      },
      ...activeConversionMetrics.map((metricInfo) => ({
        field: metricInfo.field,
        headerName: metricInfo.label,
        flex: 1,
        secondaryMetricVisible: metricInfo.canViewCost !== false,
        secondaryMetricLabel: getReportConversionCostLabel(metricInfo.label),
        valueFormatter: (params) => formatNumber(params?.value),
      })),
    ];

    if (
      !hideSpendMetrics &&
      (authUserData.is_sys_admin == 1 ||
        authUserData.user_permissions?.includes("show_gross") == true)
    ) {
      nextColumns.push({
        field: "spend",
        headerName: "Spend ($)",
        flex: 1,
        valueFormatter: (params) => `$${formatNumber(params?.value)}`,
      });
    }

    if (
      authUserData.is_sys_admin == 1 ||
      authUserData.user_permissions?.includes("show_net") == true
    ) {
      nextColumns.push({
        field: "net",
        headerName: "Net ($)",
        flex: 1,
        valueFormatter: (params) => `$${formatNumber(params?.value)}`,
      });
    }

    if (canShowRevenue) {
      activeRevenueMetrics.forEach((metricInfo) => {
        nextColumns.push({
          field: metricInfo.revenueField,
          headerName: `Revenue (${metricInfo.label})`,
          flex: 1,
          minWidth: 150,
          valueFormatter: (params) => `$${formatNumber(params?.value)}`,
        });
      });
      nextColumns.push({
        field: "roi",
        headerName: "Total Revenue ($)",
        flex: 1,
        valueGetter: (params) =>
          getTotalReportRevenue(params?.row || {}, activeRevenueMetrics),
        valueFormatter: (params) => `$${formatNumber(params?.value)}`,
      });
    }

    if (canShowConversionCost) {
      activeConversionCostMetrics.forEach((metricInfo) => {
        nextColumns.push({
          field: getConversionCostSeriesKey(metricInfo.field),
          headerName: `${getReportConversionCostLabel(metricInfo.label)} ($)`,
          flex: 1,
          minWidth: 150,
          valueGetter: (params) =>
            getConversionCostValue(params?.row || {}, metricInfo.field),
          valueFormatter: (params) => `$${formatNumber(params?.value)}`,
        });
      });
    }

    setTableColumns(nextColumns);
  }, [
    activeConversionMetrics,
    activeConversionCostMetrics,
    canShowConversionCost,
    activeRevenueMetrics,
    authUserData,
    canShowRevenue,
    getConversionCostSeriesKey,
    getConversionCostValue,
    hideSpendMetrics,
  ]);

  //On Initial Load - Show Overview Data
  // useEffect(() => {
  //   dispatch(updateTabLoaders(["tiles", "graph"]));
  //   dispatch(
  //     GetReportingOverviewSummaryDataThunk({
  //       accounts: reportingFilters.accounts,
  //       advertisers: reportingFilters.advertisers,
  //       campaigns: reportingFilters.campaigns,
  //       banners: reportingFilters.banners,
  //       start_date: reportingFilters.start_date,
  //       end_date: reportingFilters.end_date,
  //       authUserData: authUserData,
  //       label: dashboardDateFilter.label,
  //     })
  //   );
  //   dispatch(
  //     GetReportingOverviewGraphDataThunk({
  //       accounts: reportingFilters.accounts,
  //       advertisers: reportingFilters.advertisers,
  //       campaigns: reportingFilters.campaigns,
  //       banners: reportingFilters.banners,
  //       start_date: reportingFilters.start_date,
  //       end_date: reportingFilters.end_date,
  //       authUserData: authUserData,
  //       label: dashboardDateFilter.label,
  //     })
  //   );
  // }, []);

  useEffect(() => {
    //console.log("loaderUpdate", tabLoaders);
  }, [tabLoaders]);

  const FetchTabData = (Expanded, isRefresh) => {
    if (Expanded == "overview_t" && isRefresh) {
      console.log("coming inside overview_t");
      dispatch(updateTabLoaders(["tiles", "graph"]));
      if (reportCampaignId != "" && reportCampaignId != undefined) {
        setGroupBy(["campaign"]);
      }
      dispatch(
        GetReportingOverviewSummaryDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          label: dashboardDateFilter.label,
          timezone: reportingFilters.timezone,
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingOverviewGraphDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          label: dashboardDateFilter.label,
          timezone: reportingFilters.timezone,
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "type_1" &&
      (isRefresh ||
        !reportingTabsData.device_type ||
        (reportingTabsData.device_type &&
          reportingTabsData.device_type.updatedAt &&
          getMinutesDifference(reportingTabsData.device_type.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_type",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_type",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_type",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "os_1" &&
      (isRefresh ||
        !reportingTabsData.device_os ||
        (reportingTabsData.device_os &&
          reportingTabsData.device_os.updatedAt &&
          getMinutesDifference(reportingTabsData.device_os.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_os",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_os",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "device_os",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "dma_1" &&
      (isRefresh ||
        !reportingTabsData.dma ||
        (reportingTabsData.dma &&
          reportingTabsData.dma.updatedAt &&
          getMinutesDifference(reportingTabsData.dma.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "dma",
          action: "impressions",
          dmaStateCityList: dmaStateCityList,
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "dma",
          action: "clicks",
          dmaStateCityList: dmaStateCityList,
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "dma",
          action: "raw",
          dmaStateCityList: dmaStateCityList,
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "state_1" &&
      (isRefresh ||
        !reportingTabsData.state ||
        (reportingTabsData.state &&
          reportingTabsData.state.updatedAt &&
          getMinutesDifference(reportingTabsData.state.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "state",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "state",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "state",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "pin_1" &&
      (isRefresh ||
        !reportingTabsData.pin ||
        (reportingTabsData.pin &&
          reportingTabsData.pin.updatedAt &&
          getMinutesDifference(reportingTabsData.pin.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "pin",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "pin",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "pin",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "ev_1" &&
      (isRefresh ||
        !reportingTabsData.everything ||
        (reportingTabsData.everything &&
          reportingTabsData.everything.updatedAt &&
          getMinutesDifference(reportingTabsData.everything.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "everything",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "everything",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "everything",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "ssp_1" &&
      (isRefresh ||
        !reportingTabsData.ssp ||
        (reportingTabsData.ssp &&
          reportingTabsData.ssp.updatedAt &&
          getMinutesDifference(reportingTabsData.ssp.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "ssp",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "ssp",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "ssp",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      (Expanded == "campaign_campaign_1" ||
        Expanded == "package_campaign_1") &&
      (isRefresh ||
        !reportingTabsData.campaign_campaign ||
        (reportingTabsData.campaign_campaign &&
          reportingTabsData.campaign_campaign.updatedAt &&
          getMinutesDifference(reportingTabsData.campaign_campaign.updatedAt) >
            4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_campaign",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_campaign",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_campaign",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "campaign_1_day_1" &&
      (isRefresh ||
        !reportingTabsData.campaign_day ||
        (reportingTabsData.campaign_day &&
          reportingTabsData.campaign_day.updatedAt &&
          getMinutesDifference(reportingTabsData.campaign_day.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["raw"]));
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     account_id: globalAccount,
      //     tab: "campaign_day",
      //     action: "impressions",
      //     campaignId: campaignId,
      //     sdate: dashboardDateFilter.startDate,
      //     edate: dashboardDateFilter.endDate
      //   })
      // );
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     account_id: globalAccount,
      //     tab: "campaign_day",
      //     action: "clicks",
      //     campaignId: campaignId,
      //     sdate: dashboardDateFilter.startDate,
      //     edate: dashboardDateFilter.endDate
      //   })
      // );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_day",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "campaign_1_week_1" &&
      (isRefresh ||
        !reportingTabsData.campaign_week ||
        (reportingTabsData.campaign_week &&
          reportingTabsData.campaign_week.updatedAt &&
          getMinutesDifference(reportingTabsData.campaign_week.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     account_id: globalAccount,
      //     tab: "campaign_week",
      //     action: "impressions",
      //     campaignId: campaignId,
      //     sdate: dashboardDateFilter.startDate,
      //     edate: dashboardDateFilter.endDate
      //   })
      // );
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     account_id: globalAccount,
      //     tab: "campaign_week",
      //     action: "clicks",
      //     campaignId: campaignId,
      //     sdate: dashboardDateFilter.startDate,
      //     edate: dashboardDateFilter.endDate
      //   })
      // );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_week",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_week",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "campaign_1_dayofweek_1" &&
      (isRefresh ||
        !reportingTabsData.campaign_dayofweek ||
        (reportingTabsData.campaign_dayofweek &&
          reportingTabsData.campaign_dayofweek.updatedAt &&
          getMinutesDifference(reportingTabsData.campaign_dayofweek.updatedAt) >
            4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_dayofweek",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_dayofweek",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "campaign_1_hoursofday_1" &&
      (isRefresh ||
        !reportingTabsData.campaign_hoursofday ||
        (reportingTabsData.campaign_hoursofday &&
          reportingTabsData.campaign_hoursofday.updatedAt &&
          getMinutesDifference(
            reportingTabsData.campaign_hoursofday.updatedAt
          ) > 4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_hoursofday",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "campaign_hoursofday",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "creative_creative_1" &&
      (isRefresh ||
        !reportingTabsData.creative_creative ||
        (reportingTabsData.creative_creative &&
          reportingTabsData.creative_creative.updatedAt &&
          getMinutesDifference(reportingTabsData.creative_creative.updatedAt) >
            4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_creative",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_creative",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_creative",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "creative_day_1" &&
      (isRefresh ||
        !reportingTabsData.creative_day ||
        (reportingTabsData.creative_day &&
          reportingTabsData.creative_day.updatedAt &&
          getMinutesDifference(reportingTabsData.creative_day.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["impressions", "clicks", "raw"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_day",
          action: "impressions",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_day",
          action: "clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_day",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "creative_week_1" &&
      (isRefresh ||
        !reportingTabsData.creative_week ||
        (reportingTabsData.creative_week &&
          reportingTabsData.creative_week.updatedAt &&
          getMinutesDifference(reportingTabsData.creative_week.updatedAt) > 4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     accounts: reportingFilters.accounts,
      //     advertisers: reportingFilters.advertisers,
      //     campaigns: reportingFilters.campaigns,
      //     banners: reportingFilters.banners,
      //     start_date: reportingFilters.start_date,
      //     end_date: reportingFilters.end_date,
      //     tab: "creative_week",
      //     action: "impressions",
      //   })
      // );
      // dispatch(
      //   GetReportingTabsDataThunk({
      //     accounts: reportingFilters.accounts,
      //     advertisers: reportingFilters.advertisers,
      //     campaigns: reportingFilters.campaigns,
      //     banners: reportingFilters.banners,
      //     start_date: reportingFilters.start_date,
      //     end_date: reportingFilters.end_date,
      //     tab: "creative_week",
      //     action: "clicks",
      //   })
      // );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_week",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_week",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "creative_dayofweek_1" &&
      (isRefresh ||
        !reportingTabsData.creative_dayofweek ||
        (reportingTabsData.creative_dayofweek &&
          reportingTabsData.creative_dayofweek.updatedAt &&
          getMinutesDifference(reportingTabsData.creative_dayofweek.updatedAt) >
            4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_dayofweek",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_dayofweek",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    } else if (
      Expanded == "creative_hoursofday_1" &&
      (isRefresh ||
        !reportingTabsData.creative_hoursofday ||
        (reportingTabsData.creative_hoursofday &&
          reportingTabsData.creative_hoursofday.updatedAt &&
          getMinutesDifference(
            reportingTabsData.creative_hoursofday.updatedAt
          ) > 4))
    ) {
      dispatch(updateTabLoaders(["raw", "impressions_clicks"]));
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_hoursofday",
          action: "impressions_clicks",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
      dispatch(
        GetReportingTabsDataThunk({
          accounts: reportingFilters.accounts,
          advertisers: reportingFilters.advertisers,
          campaigns: reportingFilters.campaigns,
          banners: reportingFilters.banners,
          start_date: reportingFilters.start_date,
          end_date: reportingFilters.end_date,
          timezone: reportingFilters.timezone,
          tab: "creative_hoursofday",
          action: "raw",
          reportCampaignId: reportCampaignId,
          reportStartDate: reportStartDate,
          reportEndDate: reportEndDate,
        })
      );
    }
  };

  useEffect(() => {
    // not availble for districts, ios_1, android_1, websites_1
    if (Expanded) {
      FetchTabData(Expanded, false);
    }
  }, [Expanded]);

  useEffect(() => {
    if (
      reportingFilters.initial == false ||
      (reportCampaignId != "" && reportCampaignId != null)
    ) {
      if (Expanded && activeStep != 0) {
        FetchTabData(Expanded, true);
      } else if (activeStep == 0) {
        setExpanded(false);
        dispatch(updateTabLoaders(["tiles", "graph"]));
        if (reportCampaignId != "" && reportCampaignId != undefined) {
          setGroupBy(["campaign"]);
        }
      }
      if (activeStep == 7) {
        dispatch(updateTabLoaders(["tiles", "groupby_graph"]));
        applyHandler();
      } else {
        dispatch(
          GetReportingOverviewSummaryDataThunk({
            accounts: reportingFilters.accounts,
            advertisers: reportingFilters.advertisers,
            campaigns: reportingFilters.campaigns,
            banners: reportingFilters.banners,
            start_date: reportingFilters.start_date,
            end_date: reportingFilters.end_date,
            label: dashboardDateFilter.label,
            timezone: reportingFilters.timezone,
            reportCampaignId: reportCampaignId,
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
          })
        );
        dispatch(
          GetReportingOverviewGraphDataThunk({
            accounts: reportingFilters.accounts,
            advertisers: reportingFilters.advertisers,
            campaigns: reportingFilters.campaigns,
            banners: reportingFilters.banners,
            start_date: reportingFilters.start_date,
            end_date: reportingFilters.end_date,
            label: dashboardDateFilter.label,
            timezone: reportingFilters.timezone,
            reportCampaignId: reportCampaignId,
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
          })
        );
      }
    }
  }, [reportingFilters, reportCampaignId, reportStartDate, reportEndDate]);

  // delivery report
  useEffect(() => {
    if (activeStep == 7 && groupByData.graph.length <= 0) {
      applyHandler();
    }
  }, [activeStep]);
  const refreshTab = (tab) => {
    //console.log("refresh this tab ", tab);
    FetchTabData(tab, true);
  };

  const formatExportPercent = (value) => {
    const numericValue = Number(value || 0);
    const boundedValue = Math.max(0, Math.min(100, numericValue));
    return `${numberFormat(boundedValue.toFixed(2))}%`;
  };

  const getExportCtrDisplay = (row = {}) => {
    if (row?.ctr !== undefined && row?.ctr !== null && row?.ctr !== "") {
      return formatExportPercent(row?.ctr);
    }

    const impressions = Number(row?.impressions || 0);
    const clicks = Number(row?.clicks || 0);
    if (impressions <= 0 || clicks <= 0) {
      return "0%";
    }

    return formatExportPercent((clicks / impressions) * 100);
  };

  const getExportViewabilityDisplay = (row = {}) => {
    if (
      row?.viewability !== undefined &&
      row?.viewability !== null &&
      row?.viewability !== ""
    ) {
      return formatExportPercent(row?.viewability);
    }

    if (
      row?.viewables === undefined ||
      row?.viewables === null ||
      row?.viewables === ""
    ) {
      return "";
    }

    const impressions = Number(row?.impressions || 0);
    const viewables = Number(row?.viewables || 0);
    if (impressions <= 0 || viewables <= 0) {
      return "";
    }

    return formatExportPercent((viewables / impressions) * 100);
  };

  const getExportVcrDisplay = (row = {}) => {
    if (row?.vcr !== undefined && row?.vcr !== null && row?.vcr !== "") {
      return formatExportPercent(row?.vcr);
    }

    if (
      row?.complete === undefined ||
      row?.complete === null ||
      row?.complete === ""
    ) {
      return "";
    }

    const impressions = Number(row?.impressions || 0);
    const complete = Number(row?.complete || 0);
    if (impressions <= 0) {
      return "0%";
    }

    return formatExportPercent((complete / impressions) * 100);
  };

  const buildExportDataFromColumns = (rows = [], columns = []) => {
    if (!Array.isArray(rows) || !Array.isArray(columns) || columns.length <= 0) {
      return rows;
    }

    const exportColumns = columns.filter(
      (column) => column?.field && (column?.headerName || column?.field)
    );

    return rows.map((row) => {
      const exportRow = {};

      exportColumns.forEach((column) => {
        const exportHeader = column?.headerName || column?.field;
        let exportValue = row?.[column.field];

        if (typeof column?.exportValue === "function") {
          exportValue = column.exportValue(row);
        }

        exportRow[exportHeader] =
          exportValue === null || exportValue === undefined ? "" : exportValue;
      });

      return exportRow;
    });
  };

  const buildExportColumn = (field, headerName, exportValue) => ({
    field,
    headerName,
    ...(typeof exportValue === "function" ? { exportValue } : {}),
  });

  const addCalculatedMetricExportColumns = (columns = [], rows = []) => {
    if (!Array.isArray(columns) || columns.length <= 0) {
      return columns;
    }

    const fields = new Set(columns.map((column) => column?.field).filter(Boolean));
    const hasViewabilityMetric =
      fields.has("viewability") ||
      fields.has("viewables") ||
      rows.some((row) => {
        if (
          row?.viewability !== undefined &&
          row?.viewability !== null &&
          row?.viewability !== ""
        ) {
          return true;
        }

        return Number(row?.viewables || 0) > 0;
      });
    const hasCtrMetric =
      fields.has("ctr") || rows.some((row) => row?.clicks !== undefined);
    const hasVcrMetric =
      fields.has("vcr") ||
      fields.has("complete") ||
      rows.some((row) => row?.complete !== undefined);

    return columns.reduce((exportColumns, column) => {
      const field = column?.field;

      if (!field) {
        exportColumns.push(column);
        return exportColumns;
      }

      if (field === "ctr") {
        exportColumns.push({
          ...column,
          exportValue: (row) => getExportCtrDisplay(row),
        });
        return exportColumns;
      }

      if (field === "viewability") {
        exportColumns.push({
          ...column,
          exportValue: (row) => getExportViewabilityDisplay(row),
        });
        return exportColumns;
      }

      if (field === "vcr") {
        exportColumns.push({
          ...column,
          exportValue: (row) => getExportVcrDisplay(row),
        });
        return exportColumns;
      }

      exportColumns.push(column);

      if (field === "impressions" && !fields.has("viewability") && hasViewabilityMetric) {
        exportColumns.push(
          buildExportColumn("viewability", "Viewability %", (row) =>
            getExportViewabilityDisplay(row)
          )
        );
      }

      if (field === "clicks" && !fields.has("ctr") && hasCtrMetric) {
        exportColumns.push(
          buildExportColumn("ctr", "CTR", (row) => getExportCtrDisplay(row))
        );
      }

      if (field === "complete" && !fields.has("vcr") && hasVcrMetric) {
        exportColumns.push(
          buildExportColumn("vcr", "VCR", (row) => getExportVcrDisplay(row))
        );
      }

      return exportColumns;
    }, []);
  };

  const getDefaultExportColumns = (name = "") => {
    const metricColumns = Array.isArray(tableColumns) ? tableColumns : [];

    if (name.startsWith("Device_Type_")) {
      return [buildExportColumn("device_type", "Device Type"), ...metricColumns];
    }

    if (name.startsWith("Device_OS_")) {
      return [buildExportColumn("os", "OS"), ...metricColumns];
    }

    if (name.startsWith("Location_DMA_")) {
      return [buildExportColumn("dma_name", "DMA"), ...metricColumns];
    }

    if (name.startsWith("Location_State_")) {
      return [buildExportColumn("state", "State"), ...metricColumns];
    }

    if (name.startsWith("Location_Postal_Code_")) {
      return [buildExportColumn("zip", "Zip"), ...metricColumns];
    }

    if (name.startsWith("Inventory_Everything_")) {
      return [buildExportColumn("bundle", "Bundle"), ...metricColumns];
    }

    if (name.startsWith("Inventory_SSP_")) {
      return [
        buildExportColumn(
          "ssp",
          "SSP",
          (row) => row?.ssp_name || getLabelName("ssp", row?.ssp, true) || row?.ssp || ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("Campaign_Campaign_")) {
      return [
        buildExportColumn("package_name", CAMPAIGN_LABEL),
        buildExportColumn("package_id", `${CAMPAIGN_LABEL} ID`),
        ...metricColumns,
      ];
    }

    if (name.startsWith("AdGroup_AdGroup_")) {
      return [
        buildExportColumn(
          "campaign_id",
          AD_GROUP_LABEL,
          (row) =>
            row?.campaign_name ||
            getLabelName("campaign", row?.campaign_id, true) ||
            row?.campaign_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("AdGroup_Day_")) {
      return [
        buildExportColumn("date", "Date"),
        buildExportColumn(
          "campaign_id",
          AD_GROUP_LABEL,
          (row) =>
            row?.campaign_name ||
            getLabelName("campaign", row?.campaign_id, true) ||
            row?.campaign_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("AdGroup_Week_")) {
      return [
        buildExportColumn("sdate", "Start Date"),
        buildExportColumn("edate", "End Date"),
        buildExportColumn(
          "campaign_id",
          AD_GROUP_LABEL,
          (row) =>
            row?.campaign_name ||
            getLabelName("campaign", row?.campaign_id, true) ||
            row?.campaign_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("AdGroup_DayOfWeek_")) {
      return [
        buildExportColumn("dow", "Day of Week"),
        buildExportColumn(
          "campaign_id",
          AD_GROUP_LABEL,
          (row) =>
            row?.campaign_name ||
            getLabelName("campaign", row?.campaign_id, true) ||
            row?.campaign_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("AdGroup_HoursOfDay_")) {
      return [buildExportColumn("date", "Date"), ...metricColumns];
    }

    if (name.startsWith("Creative_Creative_")) {
      return [
        buildExportColumn(
          "creative_id",
          "Creative",
          (row) =>
            row?.creative_name ||
            getLabelName("creative", row?.creative_id, true) ||
            row?.creative_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("Creative_Day_")) {
      return [
        buildExportColumn("date", "Date"),
        buildExportColumn(
          "creative_id",
          "Creative",
          (row) =>
            row?.creative_name ||
            getLabelName("creative", row?.creative_id, true) ||
            row?.creative_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("Creative_Week_")) {
      return [
        buildExportColumn("sdate", "Start Date"),
        buildExportColumn("edate", "End Date"),
        buildExportColumn(
          "creative_id",
          "Creative",
          (row) =>
            row?.creative_name ||
            getLabelName("creative", row?.creative_id, true) ||
            row?.creative_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("Creative_DayOfWeek_")) {
      return [
        buildExportColumn("dow", "Day of Week"),
        buildExportColumn(
          "creative_id",
          "Creative",
          (row) =>
            row?.creative_name ||
            getLabelName("creative", row?.creative_id, true) ||
            row?.creative_id ||
            ""
        ),
        ...metricColumns,
      ];
    }

    if (name.startsWith("Creative_HoursOfDay_")) {
      return [buildExportColumn("date", "Date"), ...metricColumns];
    }

    return [];
  };

  const downloadSheetData = (data, name, columns = []) => {
    let downloadData = cloneDeep(data);
    let exportColumns = Array.isArray(columns) ? columns : [];
    var date = "";
    if (reportingFilters.end_date && reportingFilters.start_date) {
      date =
        moment(reportingFilters.start_date).format("DDMMYY") +
        "-" +
        moment(reportingFilters.end_date).format("DDMMYY");
    }

    if (name.startsWith("Campaign") || name.startsWith("AdGroup")) {
      for (let i = 0; i < downloadData.length; i++) {
        let downloadInfo = downloadData[i];
        downloadInfo.campaign_name = downloadInfo?.campaign_id
          ? getLabelName("campaign", downloadInfo?.campaign_id, true)
          : "";
        downloadData[i] = downloadInfo;
      }
    } else if (name.startsWith("Creative")) {
      for (let i = 0; i < downloadData.length; i++) {
        let downloadInfo = downloadData[i];
        downloadInfo.creative_name = downloadInfo?.creative_id
          ? getLabelName("creative", downloadInfo?.creative_id, true)
          : "";
        downloadData[i] = downloadInfo;
      }
    } else if (name.startsWith("Inventory_SSP")) {
      for (let i = 0; i < downloadData.length; i++) {
        let downloadInfo = downloadData[i];
        downloadInfo.ssp_name = downloadInfo?.ssp
          ? getLabelName("ssp", downloadInfo?.ssp, true)
          : "";
        downloadData[i] = downloadInfo;
      }
    } else if (name == "GroupBy_") {
      // let finalData = cloneDeep(data);
      const keyMap = {
        ct: "campaign_type",
        pb: "planned_budget",
        eb: "expected_budget",
        dc: "daily_cap",
        ed: "expected_delivery",
        tc: "lifetime_cap",
        cc: "campaign_currency",
      };

      const groupInfo = downloadData.map((obj) => {
        const newObj = {};
        for (let key in obj) {
          if (keyMap.hasOwnProperty(key)) {
            // Check if the key needs to be updated
            newObj[keyMap[key]] = obj[key]; // Add the updated property to the new object
          } else {
            newObj[key] = obj[key]; // Add the existing property to the new object
          }
        }
        return newObj;
      });
      downloadData = groupInfo;
    }
    if (!exportColumns.length) {
      exportColumns = getDefaultExportColumns(name);
    }
    if (exportColumns.length > 0) {
      exportColumns = addCalculatedMetricExportColumns(exportColumns, downloadData);
      downloadData = buildExportDataFromColumns(downloadData, exportColumns);
    }
    downloadData = stripPermissionHiddenReportFields(downloadData, authUserData);
    downloadJSONAsXLSX(downloadData, name + date + ".xlsx");
  };

  const handleChangeTab = (index) => {
    setActiveStep(index);
  };
  useEffect(() => {
    if (!canViewInventoryReport && activeStep === 3) {
      setActiveStep(0);
    }
    if (!canViewLocationReport && activeStep === 2) {
      setActiveStep(0);
    }
  }, [activeStep, canViewInventoryReport, canViewLocationReport]);
  const updateStepFieldValue = (valuesObj) => {
    let stepObjectData = cloneDeep(steps);
    const subCatData = stepObjectData.filter((info) => {
      if (info.id == activeStep) {
        info.fields = valuesObj;
      }
      return info;
    });
    setSteps(subCatData);
  };
  const getLabelName = (key, value, isIgnoreId = false) => {
    if (Array.isArray(value)) {
    } else if (key == "campaign" || key == "campaign_id") {
      let searchObj = globalCampaignsList.find((o) => o.value == value);
      return searchObj?.label
        ? searchObj?.label + (!isIgnoreId ? " [ID:" + value + "]" : "")
        : value;
    } else if (key == "creative" || key == "creative_id") {
      let searchObj = globalBannersList.find((o) => o.value == value);
      return searchObj?.label
        ? searchObj?.label + (!isIgnoreId ? " [ID:" + value + "]" : "")
        : value;
    } else if (key == "ssp" || key == "ssp_id") {
      let searchObj = globalPublishersList.find((o) => o.pub_code == value);
      return searchObj?.label
        ? searchObj?.label + (!isIgnoreId ? " [ID:" + value + "]" : "")
        : value;
    } else {
      return value;
    }
  };
  const renderWrappedReportLabel = (label) => (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        lineHeight: 1.35,
      }}
    >
      {label}
    </Box>
  );
  const campaignBreakdownRows =
    reportingTabsData?.campaign_campaign?.raw?.data || [];
  const campaignReportByPackageData = React.useMemo(() => {
    if (!campaignBreakdownRows.length) {
      return {
        raw: { data: [] },
        impressions: { data: [] },
        clicks: { data: [] },
      };
    }

    const campaignLookup = new Map(
      (globalCampaignsList || []).map((campaignInfo) => [
        `${campaignInfo.value}`,
        campaignInfo,
      ])
    );
    const packageLookup = new Map(
      (globalPackagesList || []).map((packageInfo) => [
        `${packageInfo.value}`,
        packageInfo,
      ])
    );
    const aggregatedMap = new Map();
    const nonAggregatedFields = new Set([
      "id",
      "package_id",
      "package_name",
      "campaign_id",
      "campaign_name",
      "account_id",
      "account_name",
      "advertiser_id",
      "advertiser_name",
      "publisher_id",
      "publisher_name",
      "placementid",
      "placement_name",
      "banner_id",
      "banner_name",
      "company",
      "imp_type",
      "device_type",
      "os",
      "dma_name",
      "state",
      "zip",
      "bundle",
      "ssp",
      "ssp_name",
      "date",
      "sdate",
      "edate",
      "dow",
      "ui_date",
      "ctr",
      "ecpm",
      "viewability",
      "vcr",
    ]);

    campaignBreakdownRows.forEach((rowInfo) => {
      const campaignMeta = campaignLookup.get(`${rowInfo?.campaign_id || ""}`);
      const packageId = `${
        rowInfo?.package_id ?? campaignMeta?.package ?? "-1"
      }`;
      const packageMeta = packageLookup.get(packageId);
      const packageName =
        rowInfo?.package_name ||
        packageMeta?.label ||
        packageMeta?.name ||
        (packageId === "-1" ? "Default Campaign" : `Campaign ${packageId}`);

      const aggregateRow =
        aggregatedMap.get(packageId) || {
          id: packageId,
          package_id: packageId,
          package_name: packageName,
        };

      if ((!aggregateRow.package_name || aggregateRow.package_name === "") && packageName) {
        aggregateRow.package_name = packageName;
      }

      Object.entries(rowInfo || {}).forEach(([field, value]) => {
        if (
          nonAggregatedFields.has(field) ||
          field.endsWith("_id") ||
          field.endsWith("_name")
        ) {
          return;
        }

        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) {
          return;
        }

        aggregateRow[field] = Number(aggregateRow?.[field] || 0) + numericValue;
      });

      aggregatedMap.set(packageId, aggregateRow);
    });

    const aggregatedRows = [...aggregatedMap.values()].map((rowInfo) => {
      const impressions = Number(rowInfo?.impressions || 0);
      const clicks = Number(rowInfo?.clicks || 0);
      const complete = Number(rowInfo?.complete || 0);
      const viewables = Number(rowInfo?.viewables || 0);

      return {
        ...rowInfo,
        ctr:
          impressions > 0
            ? Number(((clicks / impressions) * 100).toFixed(2))
            : 0,
        viewability:
          impressions > 0
            ? Number(Math.min(100, (viewables / impressions) * 100).toFixed(2))
            : 0,
        vcr:
          impressions > 0
            ? Number(((complete / impressions) * 100).toFixed(2))
            : 0,
      };
    });

    const impressionsRows = [...aggregatedRows].sort(
      (a, b) => Number(b.impressions || 0) - Number(a.impressions || 0)
    );
    const clicksRows = [...aggregatedRows].sort(
      (a, b) => Number(b.clicks || 0) - Number(a.clicks || 0)
    );

    return {
      raw: { data: impressionsRows },
      impressions: { data: impressionsRows },
      clicks: { data: clicksRows },
    };
  }, [campaignBreakdownRows, globalCampaignsList, globalPackagesList]);
  const preparePieChartLabels = (key, dbData) => {
    if (dbData != undefined && dbData != null && dbData != "") {
      let finalData = dbData.map((info) => {
        var temp = Object.assign({}, info);

        //console.log("PREPARE PIE CHART KEY:", key);
        let labelName = getLabelName(key, temp[key]);
        temp[key] = labelName;
        return temp;
      });
      return finalData;
    }
  };

  const applyHandler = () => {
    dispatch(updateTabLoaders(["tiles", "groupby_graph"]));
    dispatch(
      GetDeliveryReportingTabDataThunk({
        accounts:
          reportingFilters.accounts.length > 0
            ? reportingFilters.accounts.join(",")
            : "",
        advertisers:
          reportingFilters.advertisers.length > 0
            ? reportingFilters.advertisers.join(",")
            : "",
        campaigns:
          reportingFilters.campaigns.length > 0
            ? reportingFilters.campaigns.join(",")
            : "",
        banners:
          reportingFilters.banners.length > 0
            ? reportingFilters.banners.join(",")
            : "",
        startdate: reportingFilters.start_date,
        enddate: reportingFilters.end_date,
        timezone: reportingFilters.timezone,
        reportStartDate: reportStartDate + " 00:00:00",
        reportEndDate: reportEndDate + " 23:59:59",
        groupbys: groupBy.join(","),
        imptype: "",
        reportCampaignId: reportCampaignId,
        userData: {
          is_sys_admin: authUserData.is_sys_admin,
          user_id: authUserData.user_id,
          show_pub_names:
            authUserData.user_permissions?.includes("show_pub_names") == true
              ? 1
              : 0,
        },
      })
    ).then((res) => {
      const dbResponse = res.payload.data.results;
      //console.log("dbResponse", dbResponse);
      let groupByArr = groupBy;
      let columns = [];
      let authData = authUserData;

      console.log("authData:", authData);

      let isSysAdmin = authUserData.is_sys_admin;
      if (dbResponse && Object.keys(dbResponse).length) {
        if (groupByArr.includes("date")) {
          columns.push({ field: "date", headerName: "Date" });
        } else if (groupByArr.includes("hour")) {
          columns.push({ field: "date", headerName: "DayHour" });
        }

        if (groupByArr.includes("account")) {
          columns.push({
            field: "account_name",
            headerName: "Account",
            renderCell: (params) => {
              //if (params.company) {
              return <Box>{params.row.company}</Box>;
              //}
            },
          });
          columns.push({ field: "account_id", headerName: "Account ID" });
        }

        if (groupByArr.includes("publisher")) {
          columns.push({ field: "publisher_name", headerName: "Publisher" });
          columns.push({ field: "publisher_id", headerName: "Publisher ID" });
        }

        if (groupByArr.includes("placementid")) {
          if (!groupByArr.includes("publisher")) {
            columns.push({ field: "publisher_id", headerName: "Publisher ID" });
          }
          columns.push({ field: "placement_name", headerName: "Placement" });
          columns.push({ field: "placementid", headerName: "Placement ID" });
        }

        if (groupByArr.includes("imptype")) {
          columns.push({ field: "imp_type", headerName: "Inventory Type" });
        }

        if (groupByArr.includes("advertiser")) {
          columns.push({ field: "advertiser_name", headerName: "Advertiser" });
          columns.push({ field: "advertiser_id", headerName: "Advertiser ID" });
        }
        if (groupByArr.includes("package")) {
          columns.push({
            field: "package_name",
            headerName: CAMPAIGN_LABEL,
            renderCell: (params) => {
              if (!params.id) {
                return null;
              }

              const packageId =
                `${params.row.package_id ?? ""}` !== ""
                  ? `${params.row.package_id}`
                  : `${params.row.campaign_id ?? ""}`;
              const packageInfo =
                packageId !== ""
                  ? (globalPackagesList || []).find(
                      (info) => `${info.value}` === packageId
                    )
                  : null;
              const packageName = `${params.row.package_name ?? ""}`.trim();
              const fallbackCampaignName = `${params.row.campaign_name ?? ""}`.trim();

              return (
                <Box>
                  {packageName ||
                    packageInfo?.label ||
                    packageInfo?.name ||
                    fallbackCampaignName ||
                    (packageId === "-1"
                      ? "Default Campaign"
                      : packageId !== ""
                        ? `${CAMPAIGN_LABEL} ${packageId}`
                        : "-")}
                </Box>
              );
            },
          });
          columns.push({
            field: "package_id",
            headerName: `${CAMPAIGN_LABEL} ID`,
            renderCell: (params) => {
              if (!params.id) {
                return null;
              }

              return (
                <Box>
                  {params.row.package_id ??
                    params.row.campaign_id ??
                    "-"}
                </Box>
              );
            },
          });
        }
        if (groupByArr.includes("campaign")) {
          const hideBudget = shouldHideSpend(authData) || shouldHideCpm(authData);
          if (groupByArr.includes("advertiser") == false) {
            columns.push({
              field: "advertiser_name",
              headerName: "Advertiser",
            });
          }
          columns.push({ field: "campaign_name", headerName: AD_GROUP_LABEL });
          columns.push({
            field: "campaign_id",
            headerName: `${AD_GROUP_LABEL} ID`,
          });

          if (groupByArr.includes("banner") == false) {
            if (isSysAdmin == 1 && groupByArr.length == 1) {
              columns.push({
                field: "campaign_start",
                headerName: `${AD_GROUP_LABEL} Start Date`,
              });
              columns.push({
                field: "campaign_end",
                headerName: `${AD_GROUP_LABEL} End Date`,
              });
              columns.push({
                field: "tc",
                headerName: "Lifetime Cap",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.tc)}</Box>;
                  }
                },
              });
              columns.push({
                field: "dc",
                headerName: "Daily Cap",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.dc)}</Box>;
                  }
                },
              });
              if (!hideBudget) {
                columns.push({
                  field: "pb",
                  headerName: "Planned Budget",
                  renderCell: (params) => {
                    if (params.id) {
                      return <Box>${numberFormat(params.row.pb)}</Box>;
                    }
                  },
                });
              }
              columns.push({
                field: "impressions",
                headerName: "Impressions",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.impressions)}</Box>;
                  }
                },
              });
              if (
                !shouldHideSpend(authData) &&
                (isSysAdmin == 1 ||
                  authData.user_permissions?.includes("show_gross") == true)
              ) {
                columns.push({
                  field: "spend",
                  headerName: "Spend",
                  renderCell: (params) => {
                    if (params.id) {
                      return <Box>${numberFormat(params.row.spend)}</Box>;
                    }
                  },
                });
              }
              columns.push({
                field: "ct",
                headerName: `${AD_GROUP_LABEL} Type`,
              });
              columns.push({
                field: "ed",
                headerName: "Expected Delivery",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.ed)}</Box>;
                  }
                },
              });
              if (!hideBudget) {
                columns.push({
                  field: "eb",
                  headerName: "Expected Budget",
                  renderCell: (params) => {
                    if (params.id) {
                      return <Box>${numberFormat(params.row.eb)}</Box>;
                    }
                  },
                });
              }
            } else {
              columns.push({
                field: "campaign_start",
                headerName: `${AD_GROUP_LABEL} Start Date`,
              });
              columns.push({
                field: "campaign_end",
                headerName: `${AD_GROUP_LABEL} End Date`,
              });
              columns.push({
                field: "ct",
                headerName: `${AD_GROUP_LABEL} Type`,
              });
              columns.push({
                field: "tc",
                headerName: "Lifetime Cap",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.tc)}</Box>;
                  }
                },
              });
              columns.push({
                field: "dc",
                headerName: "Daily Cap",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.dc)}</Box>;
                  }
                },
              });
              if (!hideBudget) {
                columns.push({
                  field: "pb",
                  headerName: "Planned Budget",
                  renderCell: (params) => {
                    if (params.id) {
                      return <Box>${numberFormat(params.row.pb)}</Box>;
                    }
                  },
                });
              }
              columns.push({
                field: "ed",
                headerName: "Expected Delivery",
                renderCell: (params) => {
                  if (params.id) {
                    return <Box>{numberFormat(params.row.ed)}</Box>;
                  }
                },
              });
              if (!hideBudget) {
                columns.push({
                  field: "eb",
                  headerName: "Expected Budget",
                  renderCell: (params) => {
                    if (params.id) {
                      return <Box>${numberFormat(params.row.eb)}</Box>;
                    }
                  },
                });
              }
            }
          }
        }

        if (groupByArr.includes("banner")) {
          columns.push({ field: "banner_name", headerName: "Creative" });
          columns.push({ field: "banner_id", headerName: "Creative ID" });
        }
        if (groupByArr.includes("attribution")) {
          columns.push({ field: "attribution", headerName: "Attribution" });
        }
        if (groupByArr.includes("sales_rep")) {
          columns.push({ field: "sales_rep_name", headerName: "Sales Rep" });
          columns.push({ field: "sales_rep_id", headerName: "Sales Rep ID" });
        }

        if (groupByArr.includes("campaign") && groupByArr.length == 1) {
          columns.push({
            field: "uniques",
            headerName: "Uniques",
            renderCell: (params) => {
              if (params.id) {
                return <Box>{numberFormat(params.row.uniques)}</Box>;
              }
            },
          });
        }

        columns.push({
          field: "impressions",
          headerName: "Impressions",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.impressions)}</Box>;
            }
          },
        });
        columns.push({
          field: "viewables",
          headerName: "Viewables",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.viewables)}</Box>;
            }
          },
        });
        columns.push({
          field: "clicks",
          headerName: "Clicks",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.clicks)}</Box>;
            }
          },
        });
        columns.push({
          field: "conversions",
          headerName: conversionLabel.conv_1_label || "Conversions",
          secondaryMetricVisible:
            activeConversionMetrics.find(
              (metricInfo) => metricInfo.field === "conversions"
            )?.canViewCost !== false,
          secondaryMetricLabel: getReportConversionCostLabel(
            conversionLabel.conv_1_label || "Conversions"
          ),
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.conversions)}</Box>;
            }
          },
        });
        activeConversionMetrics
          .filter((metricInfo) => metricInfo.field !== "conversions")
          .forEach((metricInfo) => {
            columns.push({
              field: metricInfo.field,
              headerName: metricInfo.label,
              secondaryMetricVisible: metricInfo.canViewCost !== false,
              secondaryMetricLabel: getReportConversionCostLabel(
                metricInfo.label
              ),
              renderCell: (params) => {
                if (params.id) {
                  return <Box>{numberFormat(params.row[metricInfo.field])}</Box>;
                }
              },
            });
          });
        columns.push({
          field: "ctr",
          headerName: "CTR",
          renderCell: (params) => {
            if (params.id) {
              return <Box> {params.row.ctr}%</Box>;
            }
          },
        });
        if (
          !shouldHideCpm(authData) &&
          (isSysAdmin == 1 ||
            authData.user_permissions?.includes("show_net") == true)
        ) {
          columns.push({
            field: "ecpm",
            headerName: "eCPM ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.ecpm)}</Box>;
              }
            },
          });
        }

        if (
          !shouldHideSpend(authData) &&
          (isSysAdmin == 1 ||
            authData.user_permissions?.includes("show_gross") == true)
        ) {
          columns.push({
            field: "spend",
            headerName: "Spend",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.spend)}</Box>;
              }
            },
          });
        }

        if (
          isSysAdmin == 1 ||
          authData.user_permissions?.includes("show_datacost") == true
        ) {
          columns.push({
            field: "datacost",
            headerName: "Data Cost ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.datacost)}</Box>;
              }
            },
          });
        }
        if (
          !shouldHideSpend(authData) &&
          (isSysAdmin == 1 ||
            authData.user_permissions?.includes("show_gross") == true)
        ) {
          activeRevenueMetrics.forEach((metricInfo) => {
            columns.push({
              field: metricInfo.revenueField,
              headerName: `Revenue (${metricInfo.label})`,
              renderCell: (params) => {
                if (params.id) {
                  return (
                    <Box>
                      ${numberFormat(params.row?.[metricInfo.revenueField])}
                    </Box>
                  );
                }
              },
            });
          });
          columns.push({
            field: "roi",
            headerName: "Total Revenue ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box> ${numberFormat(params.value)}</Box>;
              }
            },
          });
        }
        if (
          isSysAdmin == 1 ||
          authData.user_permissions?.includes("show_margin") == true
        ) {
          columns.push({
            field: "margin",
            headerName: "Margin ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.margin)}</Box>;
              }
            },
          });
        }
        if (
          isSysAdmin == 1 ||
          authData.user_permissions?.includes("show_net") == true
        ) {
          columns.push({
            field: "net",
            headerName: "Net ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.net)}</Box>;
              }
            },
          });
        }
        if (
          isSysAdmin == 1 ||
          authData.user_permissions?.includes("show_profit") == true
        ) {
          columns.push({
            field: "profit",
            headerName: "Profit ($)",
            renderCell: (params) => {
              if (params.id) {
                return <Box>${numberFormat(params.row.profit)}</Box>;
              }
            },
          });
        }
        columns.push({
          field: "load",
          headerName: "Load",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.load)}</Box>;
            }
          },
        });
        columns.push({
          field: "start",
          headerName: "Start",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.start)}</Box>;
            }
          },
        });
        columns.push({
          field: "first_quartile",
          headerName: "First Quartile",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.first_quartile)}</Box>;
            }
          },
        });
        columns.push({
          field: "mid_point",
          headerName: "Mid Quartile",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.mid_point)}</Box>;
            }
          },
        });
        columns.push({
          field: "third_quartile",
          headerName: "Third Quartile",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.third_quartile)}</Box>;
            }
          },
        });
        columns.push({
          field: "complete",
          headerName: VIDEO_COMPLETE_LABEL,
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.complete)}</Box>;
            }
          },
        });
        columns.push({
          field: "close",
          headerName: "Close",
          renderCell: (params) => {
            if (params.id) {
              return <Box>{numberFormat(params.row.close)}</Box>;
            }
          },
        });

        const normalizedColumns = columns.map((column, index) => {
          const headerName = `${column?.headerName || ""}`;
          const isPrimaryTextColumn =
            index === 0 ||
            /campaign|ad group|creative|state|country|zip|postal|bundle|ssp|device|inventory|carrier|provider/i.test(
              headerName
            );
          const isRevenueColumn = /revenue|conversion cost/i.test(headerName);
          const isCompactMetricColumn =
            /impressions|clicks|ctr|vcr|video|sp|ftd|rd|conversion/i.test(
              headerName
            );

          return {
            ...column,
            align: column?.align || "left",
            flex:
              column?.flex ??
              (isPrimaryTextColumn ? 1.6 : isRevenueColumn ? 1.2 : 1),
            minWidth:
              column?.minWidth ??
              (isRevenueColumn
                ? 200
                : isPrimaryTextColumn
                ? 260
                : isCompactMetricColumn
                ? 130
                : 150),
          };
        });

        setGroupByColumns(normalizedColumns);

        let graphData = [];
        let summaryData = {
          impressions: 0,
          viewables: 0,
          clicks: 0,
          conversions: 0,
          conversions_2: 0,
          conversions_3: 0,
          conversions_4: 0,
          spend: 0,
          datacost: 0,
          margin: 0,
          net: 0,
          profit: 0,
          roi: 0,
        };
        const campaignLookupMap = new Map(
          (globalCampaignsList || []).map((campaignInfo) => [
            `${campaignInfo.value}`,
            campaignInfo,
          ])
        );
        const packageLookupMap = new Map(
          (globalPackagesList || []).map((packageInfo) => [
            `${packageInfo.value}`,
            packageInfo,
          ])
        );
        const creativeLookupMap = new Map(
          (globalBannersList || []).map((creativeInfo) => [
            `${creativeInfo.value}`,
            creativeInfo,
          ])
        );

        Object.keys(dbResponse).map((info) => {
          if (info != "totals") {
            const rowInfo = { ...dbResponse[info] };
            const campaignMeta = campaignLookupMap.get(
              `${rowInfo?.campaign_id ?? ""}`
            );
            const isPackageOnlyGrouping =
              groupByArr.includes("package") &&
              groupByArr.includes("campaign") == false;
            const derivedPackageId =
              rowInfo?.package_id ??
              (isPackageOnlyGrouping ? rowInfo?.campaign_id : null) ??
              campaignMeta?.package ??
              "";
            const existingPackageName = `${rowInfo?.package_name ?? ""}`.trim();
            const groupedPackageFallbackName = isPackageOnlyGrouping
              ? `${rowInfo?.campaign_name ?? ""}`.trim()
              : "";
            const resolvedPackageInfo =
              derivedPackageId !== ""
                ? packageLookupMap.get(`${derivedPackageId}`)
                : null;

            if (
              (rowInfo?.package_id == null || rowInfo?.package_id === "") &&
              derivedPackageId !== ""
            ) {
              rowInfo.package_id = derivedPackageId;
            }

            if (
              existingPackageName === "" &&
              derivedPackageId !== ""
            ) {
              rowInfo.package_name =
                resolvedPackageInfo?.label ||
                resolvedPackageInfo?.name ||
                groupedPackageFallbackName ||
                (derivedPackageId === "-1"
                  ? "Default Campaign"
                  : `${CAMPAIGN_LABEL} ${derivedPackageId}`);
            }

            if (
              (!rowInfo?.campaign_name || rowInfo?.campaign_name === "") &&
              rowInfo?.campaign_id != null &&
              rowInfo?.campaign_id !== ""
            ) {
              rowInfo.campaign_name =
                campaignLookupMap.get(`${rowInfo.campaign_id}`)?.label ||
                rowInfo.campaign_name;
            }

            if (
              (!rowInfo?.banner_name || rowInfo?.banner_name === "") &&
              rowInfo?.banner_id != null &&
              rowInfo?.banner_id !== ""
            ) {
              rowInfo.banner_name =
                creativeLookupMap.get(`${rowInfo.banner_id}`)?.label ||
                rowInfo.banner_name;
            }

            graphData.push(rowInfo);
          }
        });

        setGroupByData({
          summary:
            Object.keys(dbResponse.totals).length > 0
              ? dbResponse.totals
              : summaryData,
          graph: graphData,
        });
      }
    });
  };

  const DatagridtableHeight = window.innerHeight - 135; //136
  return (
    <>
      {globalCampaignsList.length > 0 &&
        authUserData?.user_assoc_profiles?.includes("advertiser") && (
          <ContentBox>
            <Grid
              container
              spacing={0.25}
              sx={{ mt: 0, height: "100%", minHeight: 0, overflow: "hidden" }}
            >
              <Grid
                item
                xs={12}
                md={2}
                sx={{
                  minHeight: 0,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    height: "100%",
                    minHeight: 0,
                    minWidth: 0,
                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  <CardTopSection>Configuration</CardTopSection>
                  <CardContentSection
                    sx={{ overflowY: "hidden", overflowX: "hidden" }}
                  >
                    {visibleSteps.map((item, i) => {
                      let lastItem = steps.length - i;
                      if (
                        authUserData?.user_assoc_profiles.includes(
                          "advertiser"
                        ) == false &&
                        (i == 4 || i == 5)
                      ) {
                        return "";
                      } else {
                        return (
                          <CardListStack
                            direction="row"
                            justifyContent="space-between"
                            selectedstep={item.id == activeStep ? 1 : 0}
                            key={i}
                            onClick={() => {
                              handleChangeTab(item.id);
                            }}
                            sx={{
                              paddingTop: i == 0 ? 0 : "7px",
                            }}
                          >
                            <Box>{item.name}</Box>
                            <ArrowCircleRightOutlinedIcon />
                          </CardListStack>
                        );
                      }
                    })}
                  </CardContentSection>
                  {/* <CardBottomSection> SAVE </CardBottomSection> */}
                </Card>
              </Grid>
              <Grid
                item
                xs={12}
                md={10}
                sx={{
                  minHeight: 0,
                  minWidth: 0,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    height: "100%",
                    minHeight: 0,
                    minWidth: 0,
                    width: "100%",
                    overflow: "hidden",
                  }}
                >
                  <CardTopSection sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Information
                    <RefreshIcon
                      style={{ cursor: "pointer", color: "#8595A6", fontSize: "18px" }}
                      onClick={(e) => { refreshTab("overview_t"); }}
                    />
                  </CardTopSection>
                  <CardContentSection
                    sx={{
                      pl: 1,
                      pr: 1,
                      minHeight: 0,
                      minWidth: 0,
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {activeStep == 0 && (
                      <>
                        <Grid container spacing={0.5}>
                          <Grid item xs={12} sm={6} lg={4}>
                            <ProjectCounterCard
                              tabLoaders={tabLoaders}
                              title="Impressions"
                              action="impressions"
                              CardIcon={
                                <AdjustOutlinedIcon
                                  style={{ color: "white" }}
                                  fontSize="large"
                                />
                              }
                              value={
                                reportingTiles && reportingTiles.impressions
                                  ? reportingTiles.impressions
                                  : 0
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <ProjectCounterCard
                              tabLoaders={tabLoaders}
                              title="Clicks"
                              action="clicks"
                              CardIcon={
                                <MouseOutlinedIcon
                                  style={{ color: "white" }}
                                  fontSize="large"
                                />
                              }
                              value={
                                reportingTiles && reportingTiles.clicks
                                  ? reportingTiles.clicks
                                  : 0
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={4}>
                            <ProjectCounterCard
                              tabLoaders={tabLoaders}
                              title={VIDEO_COMPLETE_LABEL}
                              CardIcon={
                                <PlayCircleOutlineOutlinedIcon
                                  style={{ color: "white" }}
                                  fontSize="large"
                                />
                              }
                              value={
                                reportingTiles && reportingTiles.complete
                                  ? reportingTiles.complete
                                  : 0
                              }
                            />
                          </Grid>
                          {activeConversionMetrics.map((metricInfo) => (
                            <Grid item xs={12} sm={6} lg={4} key={metricInfo.field}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title={metricInfo.label}
                                CardIcon={
                                  <ForumOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  reportingTiles && reportingTiles[metricInfo.field]
                                    ? reportingTiles[metricInfo.field]
                                    : 0
                                }
                              />
                            </Grid>
                          ))}
                          {!shouldHideCpm(authUserData) && (
                            <Grid item xs={12} sm={6} lg={4}>
                              <ProjectCounterCard
                                title="CPM"
                                tabLoaders={tabLoaders}
                                valueprefix="$"
                                CardIcon={
                                  <MonetizationOnOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  reportingTiles &&
                                  reportingTiles.impressions != 0 &&
                                  reportingTiles.impressions != null &&
                                  reportingTiles.spend >= 0
                                    ? (
                                        (1000 * reportingTiles.spend) /
                                        reportingTiles.impressions
                                      ).toFixed(2)
                                    : 0
                                }
                              />
                            </Grid>
                          )}

                          {!shouldHideCpm(authUserData) &&
                            (authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_net"
                              ) == true) && (
                            <Grid item xs={12} sm={6} lg={4}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title="eCPM"
                                valueprefix="$"
                                CardIcon={
                                  <MonetizationOnOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  reportingTiles &&
                                  reportingTiles.impressions != 0 &&
                                  reportingTiles.impressions != null &&
                                  reportingTiles.net >= 0
                                    ? (
                                        (1000 * reportingTiles.net) /
                                        reportingTiles.impressions
                                      ).toFixed(2)
                                    : 0
                                }
                              />
                            </Grid>
                          )}

                          {reportCampaignId != "" &&
                            reportCampaignId != null && (
                              <Grid item xs={12} sm={6} lg={4}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Available"
                                  action="available"
                                  CardIcon={
                                    <AdjustOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    reportingTiles && reportingTiles.available
                                      ? reportingTiles.available
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                          {reportCampaignId != "" &&
                            reportCampaignId != null && (
                              <Grid item xs={12} sm={6} lg={4}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Qualify"
                                  action="qualify"
                                  CardIcon={
                                    <AdjustOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    reportingTiles && reportingTiles.qualify
                                      ? reportingTiles.qualify
                                      : 0
                                  }
                                />
                              </Grid>
                            )}

                          {canShowConversionCost &&
                            activeConversionCostMetrics.map((metricInfo) => (
                              <Grid item xs={12} sm={6} lg={4} key={`overview-cost-${metricInfo.field}`}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title={getReportConversionCostLabel(metricInfo.label)}
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    reportingTiles
                                      ? getConversionCostValue(
                                          reportingTiles,
                                          metricInfo.field
                                        )
                                      : 0
                                  }
                                />
                              </Grid>
                            ))}
                          {canShowRevenue &&
                            activeRevenueMetrics.map((metricInfo) => (
                              <Grid item xs={12} sm={6} lg={4} key={metricInfo.revenueField}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title={`Revenue (${metricInfo.label})`}
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    reportingTiles?.[metricInfo.revenueField]
                                      ? Number(
                                          reportingTiles[metricInfo.revenueField]
                                        ).toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            ))}

                          {canShowRevenue && (
                            <Grid item xs={12} sm={6} lg={4}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title="Total Revenue"
                                valueprefix="$"
                                CardIcon={
                                  <MonetizationOnOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  reportingTiles
                                    ? getTotalReportRevenue(
                                        reportingTiles,
                                        activeRevenueMetrics
                                      ).toFixed(2)
                                    : 0
                                }
                              />
                            </Grid>
                          )}
                        </Grid>
                        

                        <SalesStatistics
                          tabLoaders={tabLoaders}
                          reportingTiles={reportingTiles}
                          reportingOverviewGraphData={overviewGraphData}
                          dashboardDateFilter={dashboardDateFilter}
                          detailsTab={true}
                          xAxis={"ui_date"}
                          interval={2}
                          inputLabels={inputLabels}
                          reportingLabelPostion={reportingLabelPostion}
                        />
                      </>
                    )}

                    {activeStep == 1 && (
                      <>
                        <Accordion
                          expanded={Expanded === "type_1"}
                          onChange={handleChange("type_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Device Type
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "type_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("type_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "type_1" &&
                          reportingTabsData["device_type"] &&
                          reportingTabsData["device_type"]["raw"] &&
                          reportingTabsData["device_type"]["raw"].data &&
                          reportingTabsData["device_type"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["device_type"]["raw"].data,
                                  "Device_Type_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {/*  */}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Device Types (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["device_type"]
                                    }
                                    nameKeyLabel="device_type"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Device Types (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["device_type"]
                                    }
                                    nameKeyLabel="device_type"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "device_type",
                                      headerName: "Device Type",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["device_type"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "os_1"}
                          onChange={handleChange("os_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              OS
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "os_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("os_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "os_1" &&
                          reportingTabsData["device_os"] &&
                          reportingTabsData["device_os"]["raw"] &&
                          reportingTabsData["device_os"]["raw"].data &&
                          reportingTabsData["device_os"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["device_os"]["raw"].data,
                                  "Device_OS_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Device OS (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["device_os"]
                                    }
                                    nameKeyLabel="os"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Device OS (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["device_os"]
                                    }
                                    nameKeyLabel="os"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    { field: "os", headerName: "OS", flex: 1 },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["os", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["device_os"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    )}

                    {activeStep == 2 && (
                      <>
                        <Box
                          sx={{
                            color: "red",
                            textAlign: "center",
                            mt: 5,
                            display:
                              authUserData.is_sys_admin == 0 &&
                              authUserData.user_permissions?.includes(
                                "show_dma_wrapup_report"
                              ) == false &&
                              authUserData.user_permissions?.includes(
                                "show_loc_postal_code_wrapup_report"
                              ) == false &&
                              authUserData.user_permissions?.includes(
                                "show_loc_state_wrapup_report"
                              ) == false
                                ? ""
                                : "none",
                          }}
                        >
                          Sorry! You do not have permission to view this report.
                          Please contact support.
                        </Box>
                        <Accordion
                          expanded={Expanded === "dma_1"}
                          onChange={handleChange("dma_1")}
                          sx={{
                            display:
                              authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_dma_wrapup_report"
                              ) == true
                                ? ""
                                : "none",
                          }}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              DMA
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "dma_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("dma_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "dma_1" &&
                          reportingTabsData["dma"] &&
                          reportingTabsData["dma"]["raw"] &&
                          reportingTabsData["dma"]["raw"].data &&
                          reportingTabsData["dma"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["dma"]["raw"].data,
                                  "Location_DMA_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 DMA (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={reportingTabsData["dma"]}
                                    nameKeyLabel="dma_name"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 DMA (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={reportingTabsData["dma"]}
                                    nameKeyLabel="dma_name"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "dma_name",
                                      headerName: "DMA",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["dma", ...tableColumns]}
                                action="raw"
                                reportingTabsData={reportingTabsData["dma"]}
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "state_1"}
                          onChange={handleChange("state_1")}
                          sx={{
                            display:
                              authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_loc_state_wrapup_report"
                              ) == true
                                ? ""
                                : "none",
                          }}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              State
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "state_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("state_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "state_1" &&
                          reportingTabsData["state"] &&
                          reportingTabsData["state"]["raw"] &&
                          reportingTabsData["state"]["raw"].data &&
                          reportingTabsData["state"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["state"]["raw"].data,
                                  "Location_State_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 State (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["state"]
                                    }
                                    nameKeyLabel="state"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 State (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["state"]
                                    }
                                    nameKeyLabel="state"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "state",
                                      headerName: "State",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={reportingTabsData["state"]}
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "pin_1"}
                          onChange={handleChange("pin_1")}
                          sx={{
                            display:
                              authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_loc_postal_code_wrapup_report"
                              ) == true
                                ? ""
                                : "none",
                          }}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Postal Code
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "pin_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("pin_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "pin_1" &&
                          reportingTabsData["pin"] &&
                          reportingTabsData["pin"]["raw"] &&
                          reportingTabsData["pin"]["raw"].data &&
                          reportingTabsData["pin"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["pin"]["raw"].data,
                                  "Location_Postal_Code_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Postal Code (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={reportingTabsData["pin"]}
                                    nameKeyLabel="zip"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Postal Code (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={reportingTabsData["pin"]}
                                    nameKeyLabel="zip"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "zip",
                                      headerName: "Zip",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["zip", ...tableColumns]}
                                action="raw"
                                reportingTabsData={reportingTabsData["pin"]}
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        {/* <Accordion
                  expanded={Expanded === "districts_1"}
                  onChange={handleChange("districts_1")}
              >
                <AccordionSummary
                  className="accordian_summary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    sx={{ width: "95%", flexShrink: 0 }}
                  >
                    Districts
                  </Typography>
                 
                </AccordionSummary>
                <AccordionDetails>
                  
                <>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["districts"]} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["districts"]} />
                  </Grid>
                </Grid>
                <ProductSalesList tabLoaders={tabLoaders}  columns={tableColumns} action="raw" reportingTabsData={reportingTabsData["districts"]}/>
              </>
                 
                </AccordionDetails>
              </Accordion> */}
                      </>
                    )}
                    {canViewInventoryReport && activeStep == 3 && (
                      <>
                        <Accordion
                          expanded={Expanded === "ev_1"}
                          onChange={handleChange("ev_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              All
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "ev_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("ev_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "ev_1" &&
                          reportingTabsData["everything"] &&
                          reportingTabsData["everything"]["raw"] &&
                          reportingTabsData["everything"]["raw"].data &&
                          reportingTabsData["everything"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["everything"]["raw"].data,
                                  "Inventory_Everything_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["everything"]
                                    }
                                    nameKeyLabel="bundle"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["everything"]
                                    }
                                    nameKeyLabel="bundle"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "bundle",
                                      headerName: "Bundle",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["everything"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          expanded={Expanded === "ssp_1"}
                          onChange={handleChange("ssp_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              SSP
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "ssp_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("ssp_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "ssp_1" &&
                          reportingTabsData["ssp"] &&
                          reportingTabsData["ssp"]["raw"] &&
                          reportingTabsData["ssp"]["raw"].data &&
                          reportingTabsData["ssp"]["raw"].data.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["ssp"]["raw"].data,
                                  "Inventory_SSP_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 SSPs (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={reportingTabsData["ssp"]}
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="ssp"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 SSPs (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={reportingTabsData["ssp"]}
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="ssp"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    // {
                                    //   field: "ssp",
                                    //   headerName: "SSP",
                                    //   flex: 1,
                                    // },
                                    {
                                      field: "ssp",
                                      headerName: "SSP",
                                      width: 250,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return (
                                            <Box>
                                              {getLabelName(
                                                "ssp",
                                                params.row.ssp
                                              )}
                                            </Box>
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={reportingTabsData["ssp"]}
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>

                        {/* <Accordion
                  expanded={Expanded === "ios_1"}
                  onChange={handleChange("ios_1")}
              >
                <AccordionSummary
                  className="accordian_summary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    sx={{ width: "95%", flexShrink: 0 }}
                  >
                    IOS Apps
                  </Typography>
                 
                </AccordionSummary>
                <AccordionDetails>
                  
                <>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["ios"]} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["ios"]} />
                  </Grid>
                </Grid>
                <ProductSalesList tabLoaders={tabLoaders}  columns={tableColumns} action="raw" reportingTabsData={reportingTabsData["ios"]}/>
              </>
                 
                </AccordionDetails>
              </Accordion>
              <Accordion
                  expanded={Expanded === "android_1"}
                  onChange={handleChange("android_1")}
              >
                <AccordionSummary
                  className="accordian_summary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    sx={{ width: "95%", flexShrink: 0 }}
                  >
                    Android Apps
                  </Typography>
                 
                </AccordionSummary>
                <AccordionDetails>
                  
                <>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["android"]} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["android"]} />
                  </Grid>
                </Grid>
                <ProductSalesList tabLoaders={tabLoaders}  columns={tableColumns}/>
              </>
                 
                </AccordionDetails>
              </Accordion>
              <Accordion
                  expanded={Expanded === "websites_1"}
                  onChange={handleChange("websites_1")}
              >
                <AccordionSummary
                  className="accordian_summary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    sx={{ width: "95%", flexShrink: 0 }}
                  >
                    Websites
                  </Typography>
                 
                </AccordionSummary>
                <AccordionDetails>
                  
                <>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["website"]} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["website"]} />
                  </Grid>
                </Grid>
                <ProductSalesList tabLoaders={tabLoaders}  columns={tableColumns}/>
              </>
                 
                </AccordionDetails>
              </Accordion> */}
                      </>
                    )}

                    {activeStep == 4 && (
                      <>
                        <Accordion
                          expanded={Expanded === "package_campaign_1"}
                          onChange={handleChange("package_campaign_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              {CAMPAIGN_LABEL}
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "package_campaign_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_campaign_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "package_campaign_1" &&
                          campaignReportByPackageData?.raw?.data?.length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  campaignReportByPackageData.raw.data,
                                  "Campaign_Campaign_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title={`Top 10 ${CAMPAIGN_LABEL_PLURAL} (Impressions wise)`}
                                    action="impressions"
                                    reportingTabsData={campaignReportByPackageData}
                                    nameKeyLabel="package_name"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title={`Top 10 ${CAMPAIGN_LABEL_PLURAL} (Clicks wise)`}
                                    action="clicks"
                                    reportingTabsData={campaignReportByPackageData}
                                    nameKeyLabel="package_name"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  {
                                    field: "package_name",
                                    headerName: CAMPAIGN_LABEL,
                                    width: 250,
                                  },
                                  {
                                    field: "package_id",
                                    headerName: `${CAMPAIGN_LABEL} ID`,
                                    width: 160,
                                  },
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={campaignReportByPackageData}
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    )}

                    {activeStep == 5 && (
                      <>
                        <Accordion
                          expanded={Expanded === "campaign_campaign_1"}
                          onChange={handleChange("campaign_campaign_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              {AD_GROUP_LABEL}
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "campaign_campaign_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_campaign_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "campaign_campaign_1" &&
                          reportingTabsData["campaign_campaign"] &&
                          reportingTabsData["campaign_campaign"]["raw"] &&
                          reportingTabsData["campaign_campaign"]["raw"].data &&
                          reportingTabsData["campaign_campaign"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["campaign_campaign"]["raw"]
                                    .data,
                                  "AdGroup_AdGroup_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title={`Top 10 ${AD_GROUP_LABEL_PLURAL} (Impressions wise)`}
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["campaign_campaign"]
                                    }
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="campaign_id"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title={`Top 10 ${AD_GROUP_LABEL_PLURAL} (Clicks wise)`}
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["campaign_campaign"]
                                    }
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="campaign_id"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    // {
                                    //   field: "campaign_id",
                                    //   headerName: "Campaign Id",
                                    //   flex: 1,
                                    // },
                                    {
                                      field: "campaign_id",
                                      headerName: AD_GROUP_LABEL,
                                      width: 250,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return (
                                            <Box>
                                              {getLabelName(
                                                "campaign",
                                                params.row.campaign_id
                                              )}
                                            </Box>
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["campaign_campaign"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        {/* <Accordion
                  expanded={Expanded === "targeting_ad_set_1"}
                  onChange={handleChange("targeting_ad_set_1")}
              >
                <AccordionSummary
                  className="accordian_summary"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography
                    sx={{ width: "95%", flexShrink: 0 }}
                  >
                    Targeting & Ad Set 
                  </Typography>
                 
                </AccordionSummary>
                <AccordionDetails>
                  
                <>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" />
                  </Grid>
                </Grid>
                <ProductSalesList tabLoaders={tabLoaders}  columns={tableColumns}/>
              </>
                 
                </AccordionDetails>
              </Accordion> */}
                        <Accordion
                          expanded={Expanded === "campaign_1_day_1"}
                          onChange={handleChange("campaign_1_day_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Day
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "campaign_1_day_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_1_day_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "campaign_1_day_1" &&
                          reportingTabsData["campaign_day"] &&
                          reportingTabsData["campaign_day"]["raw"] &&
                          reportingTabsData["campaign_day"]["raw"].data &&
                          reportingTabsData["campaign_day"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["campaign_day"]["raw"].data,
                                  "AdGroup_Day_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["campaign_day"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["campaign_day"]} />
                          </Grid>
                        </Grid> */}
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "date",
                                      headerName: "Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "campaign_id",
                                      headerName: AD_GROUP_LABEL,
                                      width: 250,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return (
                                            <Box>
                                              {getLabelName(
                                                "campaign",
                                                params.row.campaign_id
                                              )}
                                            </Box>
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["campaign_day"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "campaign_1_week_1"}
                          onChange={handleChange("campaign_1_week_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Week
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "campaign_1_week_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_1_week_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "campaign_1_week_1" &&
                          reportingTabsData["campaign_week"] &&
                          reportingTabsData["campaign_week"]["raw"] &&
                          reportingTabsData["campaign_week"]["raw"].data &&
                          reportingTabsData["campaign_week"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["campaign_week"]["raw"]
                                    .data,
                                  "AdGroup_Week_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["campaign_week"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["campaign_week"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["campaign_week"] &&
                                  reportingTabsData["campaign_week"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["campaign_week"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["campaign_week"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["campaign_week"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"ui_date"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "sdate",
                                      headerName: "Start Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "edate",
                                      headerName: "End Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "campaign_id",
                                      headerName: AD_GROUP_LABEL,
                                      width: 250,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return (
                                            <Box>
                                              {getLabelName(
                                                "campaign",
                                                params.row.campaign_id
                                              )}
                                            </Box>
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["campaign_week"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "campaign_1_dayofweek_1"}
                          onChange={handleChange("campaign_1_dayofweek_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Day of Week
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "campaign_1_dayofweek_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_1_dayofweek_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "campaign_1_dayofweek_1" &&
                          reportingTabsData["campaign_dayofweek"] &&
                          reportingTabsData["campaign_dayofweek"]["raw"] &&
                          reportingTabsData["campaign_dayofweek"]["raw"].data &&
                          reportingTabsData["campaign_dayofweek"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["campaign_dayofweek"]["raw"]
                                    .data,
                                  "AdGroup_DayOfWeek_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["campaign_dayofweek"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["campaign_dayofweek"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["campaign_dayofweek"] &&
                                  reportingTabsData["campaign_dayofweek"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["campaign_dayofweek"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["campaign_dayofweek"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["campaign_dayofweek"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"dow"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "dow",
                                      headerName: "Day of Week",
                                      flex: 1,
                                    },

                                    {
                                      field: "campaign_id",
                                      headerName: AD_GROUP_LABEL,
                                      width: 250,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return (
                                            <Box>
                                              {getLabelName(
                                                "campaign",
                                                params.row.campaign_id
                                              )}
                                            </Box>
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["dow", "campaign_id", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["campaign_dayofweek"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "campaign_1_hoursofday_1"}
                          onChange={handleChange("campaign_1_hoursofday_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Hours of Day
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "campaign_1_hoursofday_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("campaign_1_hoursofday_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "campaign_1_hoursofday_1" &&
                          reportingTabsData["campaign_hoursofday"] &&
                          reportingTabsData["campaign_hoursofday"]["raw"] &&
                          reportingTabsData["campaign_hoursofday"]["raw"]
                            .data &&
                          reportingTabsData["campaign_hoursofday"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["campaign_hoursofday"][
                                    "raw"
                                  ].data,
                                  "AdGroup_HoursOfDay_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["campaign_hoursofday"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["campaign_hoursofday"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["campaign_hoursofday"] &&
                                  reportingTabsData["campaign_hoursofday"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["campaign_hoursofday"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["campaign_hoursofday"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["campaign_hoursofday"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"date"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "date",
                                      headerName: "Date",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["date", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["campaign_hoursofday"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    )}

                    {activeStep == 6 && (
                      <>
                        <Accordion
                          expanded={Expanded === "creative_creative_1"}
                          onChange={handleChange("creative_creative_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Creative
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "creative_creative_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("creative_creative_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "creative_creative_1" &&
                          reportingTabsData["creative_creative"] &&
                          reportingTabsData["creative_creative"]["raw"] &&
                          reportingTabsData["creative_creative"]["raw"].data &&
                          reportingTabsData["creative_creative"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["creative_creative"]["raw"]
                                    .data,
                                  "Creative_Creative_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              <Grid container spacing={1} sx={{ mb: 0.5 }}>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Creative (Impressions wise)"
                                    action="impressions"
                                    reportingTabsData={
                                      reportingTabsData["creative_creative"]
                                    }
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="creative_id"
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6} lg={6}>
                                  <StraightAnglePieChart
                                    tabLoaders={tabLoaders}
                                    title="Top 10 Creative (Clicks wise)"
                                    action="clicks"
                                    reportingTabsData={
                                      reportingTabsData["creative_creative"]
                                    }
                                    preparePieChartLabels={
                                      preparePieChartLabels
                                    }
                                    nameKeyLabel="creative_id"
                                  />
                                </Grid>
                              </Grid>
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "creative_id",
                                      headerName: "Creative",
                                      minWidth: 320,
                                      flex: 1.2,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return renderWrappedReportLabel(
                                            getLabelName(
                                              "creative",
                                              params.row.creative_id
                                            )
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["creative_id", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["creative_creative"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          expanded={Expanded === "creative_day_1"}
                          onChange={handleChange("creative_day_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Day
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "creative_day_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("creative_day_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "creative_day_1" &&
                          reportingTabsData["creative_day"] &&
                          reportingTabsData["creative_day"]["raw"] &&
                          reportingTabsData["creative_day"]["raw"].data &&
                          reportingTabsData["creative_day"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["creative_day"]["raw"].data,
                                  "Creative_Day_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["creative_day"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["creative_day"]} />
                          </Grid>
                        </Grid> */}
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "date",
                                      headerName: "Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "creative_id",
                                      headerName: "Creative",
                                      minWidth: 320,
                                      flex: 1.2,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return renderWrappedReportLabel(
                                            getLabelName(
                                              "creative",
                                              params.row.creative_id
                                            )
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["date", "creative_id", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["creative_day"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "creative_week_1"}
                          onChange={handleChange("creative_week_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Week
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "creative_week_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("creative_week_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "creative_week_1" &&
                          reportingTabsData["creative_week"] &&
                          reportingTabsData["creative_week"]["raw"] &&
                          reportingTabsData["creative_week"]["raw"].data &&
                          reportingTabsData["creative_week"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["creative_week"]["raw"]
                                    .data,
                                  "Creative_Week_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["creative_week"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["creative_week"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["creative_week"] &&
                                  reportingTabsData["creative_week"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["creative_week"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["creative_week"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["creative_week"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"ui_date"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "sdate",
                                      headerName: "Start Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "edate",
                                      headerName: "End Date",
                                      flex: 1,
                                    },
                                    {
                                      field: "creative_id",
                                      headerName: "Creative",
                                      minWidth: 320,
                                      flex: 1.2,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return renderWrappedReportLabel(
                                            getLabelName(
                                              "creative",
                                              params.row.creative_id
                                            )
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                // columns={[
                                //   "sdate",
                                //   "edate",
                                //   "creative_id",
                                //   ...tableColumns,
                                // ]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["creative_week"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "creative_dayofweek_1"}
                          onChange={handleChange("creative_dayofweek_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Day of Week
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "creative_dayofweek_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("creative_dayofweek_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "creative_dayofweek_1" &&
                          reportingTabsData["creative_dayofweek"] &&
                          reportingTabsData["creative_dayofweek"]["raw"] &&
                          reportingTabsData["creative_dayofweek"]["raw"].data &&
                          reportingTabsData["creative_dayofweek"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["creative_dayofweek"]["raw"]
                                    .data,
                                  "Creative_DayOfWeek_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}
                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["creative_dayofweek"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["creative_dayofweek"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["creative_dayofweek"] &&
                                  reportingTabsData["creative_dayofweek"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["creative_dayofweek"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["creative_dayofweek"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["creative_dayofweek"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"dow"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "dow",
                                      headerName: "Day of Week",
                                      flex: 1,
                                    },
                                    {
                                      field: "creative_id",
                                      headerName: "Creative",
                                      minWidth: 320,
                                      flex: 1.2,
                                      renderCell: (params) => {
                                        if (params.id) {
                                          return renderWrappedReportLabel(
                                            getLabelName(
                                              "creative",
                                              params.row.creative_id
                                            )
                                          );
                                        }
                                      },
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                // columns={["dow", "creative_id", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["creative_dayofweek"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          expanded={Expanded === "creative_hoursofday_1"}
                          onChange={handleChange("creative_hoursofday_1")}
                        >
                          <AccordionSummary
                            className="accordian_summary"
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                          >
                            <Typography sx={{ width: "95%", flexShrink: 0 }}>
                              Hours of Day
                            </Typography>
                          </AccordionSummary>
                          {Expanded === "creative_hoursofday_1" ? (
                            <RefreshIcon
                              style={{
                                position: "absolute",
                                right: "45px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                refreshTab("creative_hoursofday_1");
                              }}
                            />
                          ) : (
                            ""
                          )}
                          {Expanded === "creative_hoursofday_1" &&
                          reportingTabsData["creative_hoursofday"] &&
                          reportingTabsData["creative_hoursofday"]["raw"] &&
                          reportingTabsData["creative_hoursofday"]["raw"]
                            .data &&
                          reportingTabsData["creative_hoursofday"]["raw"].data
                            .length ? (
                            <DownloadIcon
                              style={{
                                position: "absolute",
                                right: "75px",
                                top: "20px",
                                cursor: "pointer",
                              }}
                              size={20}
                              onClick={(e) => {
                                downloadSheetData(
                                  reportingTabsData["creative_hoursofday"][
                                    "raw"
                                  ].data,
                                  "Creative_HoursOfDay_"
                                );
                              }}
                            />
                          ) : (
                            ""
                          )}

                          <AccordionDetails>
                            <>
                              {/* <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Impressions" action="impressions" reportingTabsData={reportingTabsData["creative_hoursofday"]} />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={6}>
                            <StraightAnglePieChart tabLoaders={tabLoaders} title="Clicks" action="clicks" reportingTabsData={reportingTabsData["creative_hoursofday"]} />
                          </Grid>
                        </Grid> */}
                              <SalesStatistics
                                tabLoaders={tabLoaders}
                                reportingTiles={[]}
                                reportingOverviewGraphData={
                                  reportingTabsData["creative_hoursofday"] &&
                                  reportingTabsData["creative_hoursofday"][
                                    "impressions_clicks"
                                  ] &&
                                  reportingTabsData["creative_hoursofday"][
                                    "impressions_clicks"
                                  ].data &&
                                  reportingTabsData["creative_hoursofday"][
                                    "impressions_clicks"
                                  ].data.length
                                    ? reportingTabsData["creative_hoursofday"][
                                        "impressions_clicks"
                                      ].data
                                    : []
                                }
                                dashboardDateFilter={dashboardDateFilter}
                                detailsTab={false}
                                xAxis={"date"}
                                interval={1}
                                inputLabels={inputLabelsImpClicks}
                              />
                              <ProductSalesList
                                tabLoaders={tabLoaders}
                                columns={[
                                  ...[
                                    {
                                      field: "date",
                                      headerName: "Date",
                                      flex: 1,
                                    },
                                  ],
                                  ...tableColumns,
                                ]}
                                //columns={["date", ...tableColumns]}
                                action="raw"
                                reportingTabsData={
                                  reportingTabsData["creative_hoursofday"]
                                }
                              />
                            </>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    )}

                    {activeStep == 7 && (
                      <Box>
                        <Grid container spacing={0.5}>
                          <Grid item xs={12} md={6}>
                            <Autocomplete
                              id="GroupBy"
                              name="GroupBy"
                              options={GroupByList ? GroupByList : []}
                              filterSelectedOptions
                              getOptionLabel={(option) =>
                                option.label ? option.label : ""
                              }
                              limitTags={3}
                              multiple={true}
                              isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                              }
                              value={
                                groupBy != ""
                                  ? multipleSelectValues(GroupByList, groupBy)
                                  : []
                              }
                              renderOption={(props, option) => (
                                <li key={option.value} {...props}>
                                  {option.label}
                                </li>
                              )}
                              onChange={(e, newValue) => {
                                if (newValue) {
                                  let finalGroupBy = [];
                                  newValue.map((info) => {
                                    finalGroupBy.push(info.value);
                                  });
                                  setGroupBy(finalGroupBy);
                                }
                              }}
                              ListboxProps={{
                                style: {
                                  maxHeight: "150px",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  id="GroupBy"
                                  name="GroupBy"
                                  label="Group By"
                                  variant="standard"
                                  placeholder="Select GroupBy"
                                  sx={{ mb: 1 }}
                                  autoComplete="off"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                            <Box sx={{ display: "flex", flexDirection: "row" }}>
                              <Button
                                variant="contained"
                                onClick={applyHandler}
                              >
                                Apply
                              </Button>
                              {reportingTabsData["groupby_graph"] &&
                              reportingTabsData["groupby_graph"].data &&
                              reportingTabsData["groupby_graph"].data.length ? (
                                <DownloadIcon
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "15px",
                                    fontSize: "30px",
                                  }}
                                  size={20}
                                  onClick={(e) => {
                                    downloadSheetData(
                                      reportingTabsData["groupby_graph"].data,
                                      "GroupBy_",
                                      groupByColumns
                                    );
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                        <Box sx={{ mt: 2 }}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={6} lg={3}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title="Impressions"
                                action="impressions"
                                CardIcon={
                                  <AdjustOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  groupByData.summary.impressions
                                    ? groupByData.summary.impressions
                                    : 0
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title="Viewables"
                                CardIcon={
                                  <MouseOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  groupByData.summary.viewables
                                    ? groupByData.summary.viewables
                                    : 0
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title="Clicks"
                                CardIcon={
                                  <MouseOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  groupByData.summary.clicks
                                    ? groupByData.summary.clicks
                                    : 0
                                }
                              />
                            </Grid>
                          {activeConversionMetrics.map((metricInfo) => (
                            <Grid item xs={12} sm={6} lg={3} key={metricInfo.field}>
                              <ProjectCounterCard
                                tabLoaders={tabLoaders}
                                title={metricInfo.label}
                                CardIcon={
                                  <ForumOutlinedIcon
                                    style={{ color: "white" }}
                                    fontSize="large"
                                  />
                                }
                                value={
                                  groupByData.summary[metricInfo.field]
                                    ? groupByData.summary[metricInfo.field]
                                    : 0
                                }
                              />
                            </Grid>
                          ))}
                            {!shouldHideSpend(authUserData) &&
                              (authUserData.is_sys_admin == 1 ||
                                authUserData.user_permissions?.includes(
                                  "show_gross"
                                ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Spend"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary.spend
                                      ? groupByData.summary.spend.toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {(authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_datacost"
                              ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Data Cost"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary.datacost
                                      ? groupByData.summary.datacost.toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {(authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_roi_gross"
                              ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Revenue"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary
                                      ? getTotalReportRevenue(
                                          groupByData.summary,
                                          activeRevenueMetrics
                                        ).toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {(authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_margin"
                              ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Margin"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary.margin
                                      ? groupByData.summary.margin.toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {(authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_net"
                              ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Net"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary.net
                                      ? groupByData.summary.net.toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {(authUserData.is_sys_admin == 1 ||
                              authUserData.user_permissions?.includes(
                                "show_profit"
                              ) == true) && (
                              <Grid item xs={12} sm={6} lg={3}>
                                <ProjectCounterCard
                                  tabLoaders={tabLoaders}
                                  title="Profit"
                                  valueprefix="$"
                                  CardIcon={
                                    <MonetizationOnOutlinedIcon
                                      style={{ color: "white" }}
                                      fontSize="large"
                                    />
                                  }
                                  value={
                                    groupByData.summary.profit
                                      ? groupByData.summary.profit.toFixed(2)
                                      : 0
                                  }
                                />
                              </Grid>
                            )}
                            {canShowConversionCost &&
                              activeConversionCostMetrics.map((metricInfo) => (
                                <Grid item xs={12} sm={6} lg={3} key={`groupby-cost-${metricInfo.field}`}>
                                  <ProjectCounterCard
                                    tabLoaders={tabLoaders}
                                    title={getReportConversionCostLabel(metricInfo.label)}
                                    valueprefix="$"
                                    CardIcon={
                                      <MonetizationOnOutlinedIcon
                                        style={{ color: "white" }}
                                        fontSize="large"
                                      />
                                    }
                                    value={
                                      groupByData.summary
                                        ? getConversionCostValue(
                                            groupByData.summary,
                                            metricInfo.field
                                          )
                                        : 0
                                    }
                                  />
                                </Grid>
                              ))}
                          </Grid>

                          <ProductSalesList
                            tabLoaders={tabLoaders}
                            columns={groupByColumns}
                            action="groupby_graph"
                            reportingTabsData={reportingTabsData}
                          />
                        </Box>
                      </Box>
                    )}
                  </CardContentSection>
                </Card>
              </Grid>
              {/* <Grid item xs={12} md={2}>
        <Card
          sx={{
            display: "flex",Conv
            flexDirection: "column",
          }}
        >
          <CardTopSection>Filters</CardTopSection>
          <CardContentSection >
            <Stack
              direction={"row"}
              flexWrap={"wrap"}
              justifyContent={"center"}
            >
            </Stack>
          </CardContentSection>

        </Card>
      </Grid> */}
            </Grid>
            <SweetAlert ref={ToastRef} />
          </ContentBox>
        )}

      {globalCampaignsList.length <= 0 && (
        <Box sx={{ paddingTop: "2px" }}>
          <Card sx={{ p: "15px", height: "calc(100vh - 90px)" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box>This reporting only for the Advertiser data</Box>
            </Box>
          </Card>
        </Box>
      )}
    </>
  );
};

export default Reporting;
